<template>
  <section class="content">
    <div class="container-fluid">
      <h2>Profil Warga</h2>

      <div v-if="loading" class="text-muted">Memuat data...</div>

      <div v-else>
        <!-- Profile Card -->
        <div class="card shadow-sm rounded mb-4">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Informasi Pribadi</h5>
          </div>
          <div class="card-body">
            <table class="table table-borderless profile-table mb-0">
              <tbody>
                <tr>
                  <th style="width: 150px;">Nama</th>
                  <td>{{ profile.nama }}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{{ profile.email }}</td>
                </tr>
                <tr>
                  <th>No. Handphone</th>
                  <td>{{ profile.no_hp }}</td>
                </tr>
                <tr>
                  <th>Cluster</th>
                  <td>{{ profile.cluster }}</td>
                </tr>
                <tr>
                  <th>Blok</th>
                  <td>{{ profile.blok }}</td>
                </tr>
                <tr>
                  <th>No. Rumah</th>
                  <td>{{ profile.no_rumah }}</td>
                </tr>
                <tr>
                  <th>RT</th>
                  <td>{{ profile.rt }}</td>
                </tr>
                <tr>
                  <th>RW</th>
                  <td>{{ profile.rw }}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>

        <!-- Kendaraan Card -->
        <div class="card shadow-sm rounded">
          <div class="card-header bg-success text-white">
            <h5 class="mb-0">Daftar Kendaraan</h5>
          </div>
          <div class="card-body">
            <ul class="list-group">
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
                v-for="(item, index) in profile.kendaraan"
                :key="index"
              >
                {{ item.type_kendaraan }}
                <span class="badge bg-info" style="font-size: larger;">{{ item.plat_nomor }}</span>
              </li>
            </ul>
            <div class="text-center mt-4">
              <button
                @click="goToDashboard"
                class="btn btn-outline-primary"
              >
                <i class="fas fa-edit me-2"></i>
                Ubah Data
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import alert from '@/utils/alert'

const router = useRouter()

const goToDashboard = () => {
  alert.custom('Anda yakin ingin merubah data ini?').then((result) => {
  if (result.isConfirmed) {
      // lanjutkan proses
        router.push('/dashboard')
    }
  })
}

const profile = ref({
  name: '',
  email: '',
  nohp: '',
  cluster: '',
  rt: '',
  rw: '',
  blok: '',
  norumah: '',
  kendaraan: [], // ← array kendaraan
})
const loading = ref(true)

onMounted(async () => {
  const email = localStorage.getItem('username')
  const token = localStorage.getItem('token')

  if (!token) {
    alert.error('Unauthorized!')
    router.push('/')
  }

  const ProfileData = {
    email: email,
    token: token,
  }

  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-vms-get-profile.php', {
      params: ProfileData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.data.status === 200) {
      profile.value = response.data.data
    } else {
      alert(response.data.message || 'Gagal mengambil data profil.')
    }

  } catch (err) {
    console.error(err)
    alert('Gagal mengambil data.')
  } finally {
    loading.value = false
  }
})

</script>

